(function() {
    const accordion__item = document.querySelectorAll('.horizontal-accordion__item');
    const horizontal_accordion = debounce(function () {
        function accordion_action(event) {
            const is_full_accordion = this.closest('.horizontal-accordion').classList.contains('full-accordion')

            if (!is_full_accordion && window.outerWidth <= 766) {
                return
            }

            const wrapper = this.parentElement
            const all_items = wrapper.querySelectorAll('.horizontal-accordion__item')

            all_items.forEach(function (item) {
                const item_title = item.querySelector('.horizontal-accordion__title')
                item.classList.remove('horizontal-accordion__item--active')
                item_title.setAttribute('aria-expanded', false)
                item_title.setAttribute('aria-disabled', false)
                item_title.removeAttribute('tabindex')
                item.querySelector('.horizontal-accordion__text-wrapper').setAttribute('aria-hidden', true)
                item.querySelectorAll('.horizontal-accordion__text-wrapper a').forEach((function(x){ x.setAttribute("tabindex","-1");}))
             })

            this.classList.add('horizontal-accordion__item--active')
            const item_title = this.querySelector('.horizontal-accordion__title')
            item_title.setAttribute('aria-expanded', true)
            item_title.setAttribute('aria-disabled', true)
            item_title.setAttribute('tabindex','-1')
            this.querySelector('.horizontal-accordion__text-wrapper').setAttribute('aria-hidden', false)
            this.querySelectorAll('.horizontal-accordion__text-wrapper a').forEach((function(x){ x.removeAttribute("tabindex");}))

            if (is_full_accordion && window.outerWidth <= 766) {
                setTimeout(() => {
                    const bounding = item_title.getBoundingClientRect()
                    if (
                        !(
                            bounding.top >= 0 &&
                            bounding.left >= 0 &&
                            bounding.right <= window.innerWidth &&
                            bounding.bottom <= window.innerHeight
                        )
                    ) {
                        item_title.scrollIntoView({ behavior: 'smooth', block: 'start' })
                    }
                }, 300)
            }
        }

        accordion__item.forEach(function (item) {
            const item_title = item.querySelector('.horizontal-accordion__title')
            const item_content = item.querySelector('.horizontal-accordion__text-wrapper')

            item_title.addEventListener('click', event => event.preventDefault())

            item.addEventListener('click', accordion_action, true)
            item.addEventListener('keypress', accordion_action, true)

            const is_full_accordion = item.closest('.horizontal-accordion').classList.contains('full-accordion')

            if (!is_full_accordion) {
                // On non-full accordions, for mobile we break the accordion and display all contents in a stacked layout.
                if (window.outerWidth <= 766) {
                    item.removeAttribute('tabindex')
                    item.removeAttribute('role')
                    item_title.removeAttribute('role')
                    item_title.removeAttribute('aria-expanded')
                    item_title.removeAttribute('aria-disabled')
                    item_title.removeAttribute('aria-controls')
                    item_content.removeAttribute('role')
                    item_content.removeAttribute('aria-hidden')
                    item_content.removeAttribute('aria-labelledby')
                } else if (item.classList.contains('horizontal-accordion__item--active')) {
                    // Reset active item when viewport is wide enough
                    item.setAttribute('tabindex', 0)
                    item.setAttribute('role', 'presentation')
                    item_title.setAttribute('role', 'button')
                    item_title.setAttribute('aria-expanded', true)
                    item_title.setAttribute('aria-disabled', true)
                    item_title.setAttribute('aria-controls', item_content.id)
                    item_content.setAttribute('role', 'region')
                    item_content.setAttribute('aria-hidden', false)
                    item_content.setAttribute('aria-labelledby', item_title.id)
                } else {
                    // Reset non-active item when viewport is wide enough
                    item.setAttribute('tabindex', 0)
                    item.setAttribute('role', 'presentation')
                    item_title.setAttribute('role', 'button')
                    item_title.setAttribute('aria-expanded', false)
                    item_title.setAttribute('aria-disabled', false)
                    item_title.setAttribute('aria-controls', item_content.id)
                    item_content.setAttribute('role', 'region')
                    item_content.setAttribute('aria-hidden', true)
                    item_content.setAttribute('aria-labelledby', item_title.id)
                }
            }
            else {
                if (item.classList.contains('horizontal-accordion__item--active')) {
                    item_title.setAttribute('tabindex','-1')
                    item_content.querySelectorAll('a').forEach((function(x){ x.removeAttribute("tabindex");}))
                } else {
                    item_title.removeAttribute('tabindex')
                    item_content.querySelectorAll('a').forEach((function(x){ x.setAttribute("tabindex","-1");}))
                }
            }
        })
    }, 600)

    window.addEventListener('resize', horizontal_accordion)
    document.addEventListener('DOMContentLoaded', horizontal_accordion)

})();
